import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

const INITIAL_STATE = Immutable({
  loading: false,
  result: {},
});

export const { Creators, Types } = createActions({
  calculateCurrencyRequested: ['currencyData'],
  calculateCurrencySuccess: ['result'],
  calculateCurrencyError: ['error'],
});

export const Selectors = {
  // Selector will be here...
};

export const Reducer = createReducer(INITIAL_STATE, {
  [Types.CALCULATE_CURRENCY_REQUESTED]: state => state.merge({ loading: true }),
  [Types.CALCULATE_CURRENCY_SUCCESS]: (state, { result }) => state.merge({ loading: false, result }),
  [Types.CALCULATE_CURRENCY_ERROR]: state => state.merge({ loading: false }),
});
